<template>
    <v-container>
        <h1>Mes vacances</h1>
        <v-data-table
            :items="filteredVacances"
            :headers="labels"
            class="elevation-1"
            :loading="loading"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            loading-text="Chargement..."
            ><template v-slot:item.debut="{ item }">
            {{utils.toPrettyDate(item.debut)}}
        </template>
        <template v-slot:item.fin="{ item }">
            {{utils.toPrettyDate(item.fin)}}
        </template></v-data-table>
    </v-container>
</template>

<script>
import api from "@/api";
import moment from "moment";
import utils from "@/utils";
import store from "@/store";

export default {
    data() {
        return {
            vacances: [],
            labels: [
                {value:"debut", text:"Du", sortable:true},
                {value:"fin", text:"Au", sortable: true}
            ],
            utils: utils,
            sortBy: "debut",
            sortDesc: false,
        }
    },
    created(){
        this.loadData();
    },
    methods: {
        async loadData() {
            this.$store.commit("setLoading", true);
            this.vacances = (await api.getVacances()).data.vacances;
            this.$store.commit("setLoading", false);
        }
    },
    computed: {
        loading() {
            return store.state.loading;
        },
        filteredVacances() {
            return this.vacances.filter(vacance => {
                return !moment(vacance.fin).isBefore(moment().add(-1,'day'));
            });
        }
    }
}
</script>
